import { ContentType } from '@/api'

export default (file: File) => (file.type || 'application/pdf') as
  | ContentType
  | null
  | undefined